import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {SiteZoneDto} from '../model/site-zone.dto';

@Injectable({
	providedIn: 'root'
})
export class SelectionZoneService {
	private url = '/ws/sites';

	constructor(private http: HttpClient) {
	}

	/**
	 * Recherche les sites et zones autorisés en fonction de l'équipe de l'utilisateur.
	 * @param loginUtilisateur le login de l'utilisateur.
	 */
	rechercherSitesEtZonesAutorises(loginUtilisateur: string): Observable<SiteZoneDto[]> {
		return this.http.get<SiteZoneDto[]>(`${this.url}/${loginUtilisateur}`);
	}
}
